import { useSearchParams } from 'react-router-dom';
import { PageHeader, Tabs, TabList, TabTrigger, TabContent } from '@/components/ui';
import { PageContainer } from '@/components/layout';
import { NewsTab } from '@/components/admin/homepage-content/NewsTab';
import { UpcomingTab } from '@/components/admin/homepage-content/UpcomingTab';

const VALID_TABS = ['news', 'upcoming'] as const;
type AdminHomepageTab = (typeof VALID_TABS)[number];

function isValidTab(value: string | null): value is AdminHomepageTab {
  return value !== null && (VALID_TABS as readonly string[]).includes(value);
}

export function AdminHomepageContentPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawTab = searchParams.get('tab');
  const activeTab: AdminHomepageTab = isValidTab(rawTab) ? rawTab : 'news';

  const handleTabChange = (next: string): void => {
    if (!isValidTab(next)) return;
    const params = new URLSearchParams(searchParams);
    params.set('tab', next);
    setSearchParams(params, { replace: true });
  };

  return (
    <PageContainer variant="wide" className="space-y-6 p-4 md:p-6 lg:p-8">
      <PageHeader
        title="Homepage content"
        subtitle="Manage the What's New and What's Coming feeds shown on /."
      />
      <Tabs value={activeTab} onValueChange={handleTabChange}>
        <TabList>
          <TabTrigger value="news">News</TabTrigger>
          <TabTrigger value="upcoming">What&apos;s Coming</TabTrigger>
        </TabList>
        <TabContent value="news">
          <NewsTab />
        </TabContent>
        <TabContent value="upcoming">
          <UpcomingTab />
        </TabContent>
      </Tabs>
    </PageContainer>
  );
}
